import { put } from "redux-saga/effects";
import AppActions from "./AppRedux";

export function* startup() {
  yield put(AppActions.setLoaded(true));
}
